"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.filterAsyncRoutes = filterAsyncRoutes;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
var _router = require("@/router");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(menu, route, parentRouter) {
  if (parentRouter == null) {
    var routerPath = route.path;
    if (menu[routerPath]) {
      return true;
    }
  } else {
    var parentRouterPath = parentRouter.path;
    if (parentRouterPath === "/") {
      var _routerPath = route.path;
      _routerPath = parentRouterPath + _routerPath;
      if (menu[_routerPath]) {
        return true;
      }
    } else {
      var _routerPath2 = route.path;
      _routerPath2 = parentRouterPath + "/" + _routerPath2;
      if (menu[_routerPath2]) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, menu, parentRouter) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(menu, tmp, parentRouter)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, menu, tmp);
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = _router.constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, obj) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      //可用的菜单
      var menuabled = {};
      for (var i = 0; i < obj.data.length; ++i) {
        menuabled[obj.data[i].routerPath] = true;
      }
      /**
       * obj.orgGroup.orgGroupCode
       * 可以组织组展示不通首页
       */
      var accessedRoutes = filterAsyncRoutes(_router.asyncRoutes, menuabled, null);
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};